import request from '@/util/request';
import qs from 'qs';

export const getUserList = (params, options) =>
  request.get('/api/v4ward/user/userPhone-list', Object.assign({}, options, {
    params
  }));

export const getFeeTypes = (params, options) =>
  request.get('/api/v4ward/charge/user/getFeeTypes?code=offline_fee_type', Object.assign({}, options, {
    params
  }));

  
export const getCommunityGroupList = (params, options) =>
request.get('/api/base/property/common/communityGroup', Object.assign({}, options, { params }));

export const getOptionNode = (params, options) =>
  request.get('/api/base/property/optionNode', Object.assign({}, options, { params }));